import React from 'react';
import { motion } from 'framer-motion';
interface SlideLayoutProps {
  children: ReactNode;
  className?: string;
}
export function SlideLayout({
  children,
  className = ''
}: SlideLayoutProps) {
  return <motion.div className={`min-h-[calc(100vh-160px)] w-full flex flex-col justify-center px-4 sm:px-8 md:px-16 lg:px-24 max-w-7xl mx-auto py-20 pb-32 ${className}`} initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-386">
      {children}
    </motion.div>;
}